import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface States {
  tabIndex: number;
}

const initialState: States = {
  tabIndex: 0,
};

export const bookingsEditBookingSlice = createSlice({
  initialState,
  name: 'bookingsEditBooking',
  reducers: {
    setTabIndex: (state, { payload }: PayloadAction<number>) => {
      state.tabIndex = payload;
    },
  },
});

export default bookingsEditBookingSlice.reducer;

export const { setTabIndex: setTabIndexAction } = bookingsEditBookingSlice.actions;
